import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"],
  _excluded4 = ["data"],
  _excluded5 = ["data"],
  _excluded6 = ["data"],
  _excluded7 = ["data"],
  _excluded8 = ["data"],
  _excluded9 = ["data"],
  _excluded10 = ["data"],
  _excluded11 = ["data"],
  _excluded12 = ["data"],
  _excluded13 = ["data"],
  _excluded14 = ["data"],
  _excluded15 = ["data"],
  _excluded16 = ["data"],
  _excluded17 = ["data"],
  _excluded18 = ["data"],
  _excluded19 = ["data"],
  _excluded20 = ["data"],
  _excluded21 = ["data"],
  _excluded22 = ["data"],
  _excluded23 = ["data"],
  _excluded24 = ["data"],
  _excluded25 = ["data"],
  _excluded26 = ["data"],
  _excluded27 = ["data"],
  _excluded28 = ["data"],
  _excluded29 = ["data"],
  _excluded30 = ["data"],
  _excluded31 = ["data"],
  _excluded32 = ["data"],
  _excluded33 = ["data"],
  _excluded34 = ["data"],
  _excluded35 = ["data"],
  _excluded36 = ["data"],
  _excluded37 = ["data"],
  _excluded38 = ["data"],
  _excluded39 = ["data"],
  _excluded40 = ["data"],
  _excluded41 = ["data"],
  _excluded42 = ["data"],
  _excluded43 = ["data"],
  _excluded44 = ["data"],
  _excluded45 = ["data"],
  _excluded46 = ["data"],
  _excluded47 = ["data"],
  _excluded48 = ["data"],
  _excluded49 = ["data"],
  _excluded50 = ["data"],
  _excluded51 = ["data"],
  _excluded52 = ["data"],
  _excluded53 = ["data"],
  _excluded54 = ["data"],
  _excluded55 = ["data"],
  _excluded56 = ["data"],
  _excluded57 = ["data"],
  _excluded58 = ["data"],
  _excluded59 = ["data"],
  _excluded60 = ["data"],
  _excluded61 = ["data"],
  _excluded62 = ["data"],
  _excluded63 = ["data"];
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.ai.agent.rpc.AiAgentInstancesChirpServiceV2
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery, useMutation } from 'data-fetching-client';
import * as Queries from './AiAgentInstancesChirpServiceV2.dfc.new';
export function useGetAgentInstanceQuery(options) {
  const _useQuery = useQuery(Queries.GET_AGENT_INSTANCE_QUERY, options),
    {
      data
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstanceLazyQuery(options) {
  const [getter, _ref] = useLazyQuery(Queries.GET_AGENT_INSTANCE_QUERY, options);
  const {
      data
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded2);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAgentInstanceSuspenseQuery(options) {
  const _useSuspenseQuery = useSuspenseQuery(Queries.GET_AGENT_INSTANCE_QUERY, options),
    {
      data
    } = _useSuspenseQuery,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery, _excluded3);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesByIDsQuery(options) {
  const _useQuery2 = useQuery(Queries.GET_AGENT_INSTANCES_BY_IDS_QUERY, options),
    {
      data
    } = _useQuery2,
    rest = _objectWithoutPropertiesLoose(_useQuery2, _excluded4);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByIDs: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesByIDsLazyQuery(options) {
  const [getter, _ref2] = useLazyQuery(Queries.GET_AGENT_INSTANCES_BY_IDS_QUERY, options);
  const {
      data
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded5);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByIDs: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAgentInstancesByIDsSuspenseQuery(options) {
  const _useSuspenseQuery2 = useSuspenseQuery(Queries.GET_AGENT_INSTANCES_BY_IDS_QUERY, options),
    {
      data
    } = _useSuspenseQuery2,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery2, _excluded6);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByIDs: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesWithSnapshotsQuery(options) {
  const _useQuery3 = useQuery(Queries.GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY, options),
    {
      data
    } = _useQuery3,
    rest = _objectWithoutPropertiesLoose(_useQuery3, _excluded7);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesWithSnapshots: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesWithSnapshotsLazyQuery(options) {
  const [getter, _ref3] = useLazyQuery(Queries.GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY, options);
  const {
      data
    } = _ref3,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded8);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesWithSnapshots: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAgentInstancesWithSnapshotsSuspenseQuery(options) {
  const _useSuspenseQuery3 = useSuspenseQuery(Queries.GET_AGENT_INSTANCES_WITH_SNAPSHOTS_QUERY, options),
    {
      data
    } = _useSuspenseQuery3,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery3, _excluded9);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesWithSnapshots: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesByWorkflowIdQuery(options) {
  const _useQuery4 = useQuery(Queries.GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY, options),
    {
      data
    } = _useQuery4,
    rest = _objectWithoutPropertiesLoose(_useQuery4, _excluded10);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByWorkflowId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesByWorkflowIdLazyQuery(options) {
  const [getter, _ref4] = useLazyQuery(Queries.GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY, options);
  const {
      data
    } = _ref4,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded11);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByWorkflowId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAgentInstancesByWorkflowIdSuspenseQuery(options) {
  const _useSuspenseQuery4 = useSuspenseQuery(Queries.GET_AGENT_INSTANCES_BY_WORKFLOW_ID_QUERY, options),
    {
      data
    } = _useSuspenseQuery4,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery4, _excluded12);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByWorkflowId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesByStatusQuery(options) {
  const _useQuery5 = useQuery(Queries.GET_AGENT_INSTANCES_BY_STATUS_QUERY, options),
    {
      data
    } = _useQuery5,
    rest = _objectWithoutPropertiesLoose(_useQuery5, _excluded13);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByStatus: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetAgentInstancesByStatusLazyQuery(options) {
  const [getter, _ref5] = useLazyQuery(Queries.GET_AGENT_INSTANCES_BY_STATUS_QUERY, options);
  const {
      data
    } = _ref5,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded14);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByStatus: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetAgentInstancesByStatusSuspenseQuery(options) {
  const _useSuspenseQuery5 = useSuspenseQuery(Queries.GET_AGENT_INSTANCES_BY_STATUS_QUERY, options),
    {
      data
    } = _useSuspenseQuery5,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery5, _excluded15);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getAgentInstancesByStatus: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetActiveAgentInstancesQuery(options) {
  const _useQuery6 = useQuery(Queries.GET_ACTIVE_AGENT_INSTANCES_QUERY, options),
    {
      data
    } = _useQuery6,
    rest = _objectWithoutPropertiesLoose(_useQuery6, _excluded16);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getActiveAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetActiveAgentInstancesLazyQuery(options) {
  const [getter, _ref6] = useLazyQuery(Queries.GET_ACTIVE_AGENT_INSTANCES_QUERY, options);
  const {
      data
    } = _ref6,
    rest = _objectWithoutPropertiesLoose(_ref6, _excluded17);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getActiveAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetActiveAgentInstancesSuspenseQuery(options) {
  const _useSuspenseQuery6 = useSuspenseQuery(Queries.GET_ACTIVE_AGENT_INSTANCES_QUERY, options),
    {
      data
    } = _useSuspenseQuery6,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery6, _excluded18);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getActiveAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useListAgentInstancesQuery(options) {
  const _useQuery7 = useQuery(Queries.LIST_AGENT_INSTANCES_QUERY, options),
    {
      data
    } = _useQuery7,
    rest = _objectWithoutPropertiesLoose(_useQuery7, _excluded19);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    listAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useListAgentInstancesLazyQuery(options) {
  const [getter, _ref7] = useLazyQuery(Queries.LIST_AGENT_INSTANCES_QUERY, options);
  const {
      data
    } = _ref7,
    rest = _objectWithoutPropertiesLoose(_ref7, _excluded20);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    listAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useListAgentInstancesSuspenseQuery(options) {
  const _useSuspenseQuery7 = useSuspenseQuery(Queries.LIST_AGENT_INSTANCES_QUERY, options),
    {
      data
    } = _useSuspenseQuery7,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery7, _excluded21);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    listAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useSearchAgentInstancesQuery(options) {
  const _useQuery8 = useQuery(Queries.SEARCH_AGENT_INSTANCES_QUERY, options),
    {
      data
    } = _useQuery8,
    rest = _objectWithoutPropertiesLoose(_useQuery8, _excluded22);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    searchAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useSearchAgentInstancesLazyQuery(options) {
  const [getter, _ref8] = useLazyQuery(Queries.SEARCH_AGENT_INSTANCES_QUERY, options);
  const {
      data
    } = _ref8,
    rest = _objectWithoutPropertiesLoose(_ref8, _excluded23);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    searchAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSearchAgentInstancesSuspenseQuery(options) {
  const _useSuspenseQuery8 = useSuspenseQuery(Queries.SEARCH_AGENT_INSTANCES_QUERY, options),
    {
      data
    } = _useSuspenseQuery8,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery8, _excluded24);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    searchAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useCreateAgentInstanceMutation(options) {
  const [getter, _ref9] = useMutation(Queries.CREATE_AGENT_INSTANCE_MUTATION, options);
  const {
      data
    } = _ref9,
    rest = _objectWithoutPropertiesLoose(_ref9, _excluded25);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    createAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useUpdateAgentInstanceMutation(options) {
  const [getter, _ref10] = useMutation(Queries.UPDATE_AGENT_INSTANCE_MUTATION, options);
  const {
      data
    } = _ref10,
    rest = _objectWithoutPropertiesLoose(_ref10, _excluded26);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    updateAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useUpdateAgentInstanceV2Mutation(options) {
  const [getter, _ref11] = useMutation(Queries.UPDATE_AGENT_INSTANCE_V2_MUTATION, options);
  const {
      data
    } = _ref11,
    rest = _objectWithoutPropertiesLoose(_ref11, _excluded27);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    updateAgentInstanceV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useFactoryResetMutation(options) {
  const [getter, _ref12] = useMutation(Queries.FACTORY_RESET_MUTATION, options);
  const {
      data
    } = _ref12,
    rest = _objectWithoutPropertiesLoose(_ref12, _excluded28);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    factoryReset: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useFactoryResetV2Mutation(options) {
  const [getter, _ref13] = useMutation(Queries.FACTORY_RESET_V2_MUTATION, options);
  const {
      data
    } = _ref13,
    rest = _objectWithoutPropertiesLoose(_ref13, _excluded29);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    factoryResetV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useResetToLatestTemplateMutation(options) {
  const [getter, _ref14] = useMutation(Queries.RESET_TO_LATEST_TEMPLATE_MUTATION, options);
  const {
      data
    } = _ref14,
    rest = _objectWithoutPropertiesLoose(_ref14, _excluded30);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    resetToLatestTemplate: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSoftDeleteAgentInstanceMutation(options) {
  const [getter, _ref15] = useMutation(Queries.SOFT_DELETE_AGENT_INSTANCE_MUTATION, options);
  const {
      data
    } = _ref15,
    rest = _objectWithoutPropertiesLoose(_ref15, _excluded31);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    softDeleteAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSoftDeleteAgentInstanceV2Mutation(options) {
  const [getter, _ref16] = useMutation(Queries.SOFT_DELETE_AGENT_INSTANCE_V2_MUTATION, options);
  const {
      data
    } = _ref16,
    rest = _objectWithoutPropertiesLoose(_ref16, _excluded32);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    softDeleteAgentInstanceV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useCreateInstanceFromTemplateMutation(options) {
  const [getter, _ref17] = useMutation(Queries.CREATE_INSTANCE_FROM_TEMPLATE_MUTATION, options);
  const {
      data
    } = _ref17,
    rest = _objectWithoutPropertiesLoose(_ref17, _excluded33);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    createInstanceFromTemplate: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useCreateInstanceFromTemplateByGlobalIdMutation(options) {
  const [getter, _ref18] = useMutation(Queries.CREATE_INSTANCE_FROM_TEMPLATE_BY_GLOBAL_ID_MUTATION, options);
  const {
      data
    } = _ref18,
    rest = _objectWithoutPropertiesLoose(_ref18, _excluded34);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    createInstanceFromTemplateByGlobalId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useCloneAgentInstanceMutation(options) {
  const [getter, _ref19] = useMutation(Queries.CLONE_AGENT_INSTANCE_MUTATION, options);
  const {
      data
    } = _ref19,
    rest = _objectWithoutPropertiesLoose(_ref19, _excluded35);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    cloneAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useCloneAgentsForFlowMutation(options) {
  const [getter, _ref20] = useMutation(Queries.CLONE_AGENTS_FOR_FLOW_MUTATION, options);
  const {
      data
    } = _ref20,
    rest = _objectWithoutPropertiesLoose(_ref20, _excluded36);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    cloneAgentsForFlow: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetInstancesByTemplateIdsQuery(options) {
  const _useQuery9 = useQuery(Queries.GET_INSTANCES_BY_TEMPLATE_IDS_QUERY, options),
    {
      data
    } = _useQuery9,
    rest = _objectWithoutPropertiesLoose(_useQuery9, _excluded37);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getInstancesByTemplateIds: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetInstancesByTemplateIdsLazyQuery(options) {
  const [getter, _ref21] = useLazyQuery(Queries.GET_INSTANCES_BY_TEMPLATE_IDS_QUERY, options);
  const {
      data
    } = _ref21,
    rest = _objectWithoutPropertiesLoose(_ref21, _excluded38);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getInstancesByTemplateIds: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetInstancesByTemplateIdsSuspenseQuery(options) {
  const _useSuspenseQuery9 = useSuspenseQuery(Queries.GET_INSTANCES_BY_TEMPLATE_IDS_QUERY, options),
    {
      data
    } = _useSuspenseQuery9,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery9, _excluded39);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getInstancesByTemplateIds: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetInstancesByGlobalIdQuery(options) {
  const _useQuery10 = useQuery(Queries.GET_INSTANCES_BY_GLOBAL_ID_QUERY, options),
    {
      data
    } = _useQuery10,
    rest = _objectWithoutPropertiesLoose(_useQuery10, _excluded40);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getInstancesByGlobalId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useGetInstancesByGlobalIdLazyQuery(options) {
  const [getter, _ref22] = useLazyQuery(Queries.GET_INSTANCES_BY_GLOBAL_ID_QUERY, options);
  const {
      data
    } = _ref22,
    rest = _objectWithoutPropertiesLoose(_ref22, _excluded41);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getInstancesByGlobalId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useGetInstancesByGlobalIdSuspenseQuery(options) {
  const _useSuspenseQuery10 = useSuspenseQuery(Queries.GET_INSTANCES_BY_GLOBAL_ID_QUERY, options),
    {
      data
    } = _useSuspenseQuery10,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery10, _excluded42);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    getInstancesByGlobalId: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useUploadFilesToAgentInstanceMutation(options) {
  const [getter, _ref23] = useMutation(Queries.UPLOAD_FILES_TO_AGENT_INSTANCE_MUTATION, options);
  const {
      data
    } = _ref23,
    rest = _objectWithoutPropertiesLoose(_ref23, _excluded43);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    uploadFilesToAgentInstance: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useFindComponentUsageQuery(options) {
  const _useQuery11 = useQuery(Queries.FIND_COMPONENT_USAGE_QUERY, options),
    {
      data
    } = _useQuery11,
    rest = _objectWithoutPropertiesLoose(_useQuery11, _excluded44);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    findComponentUsage: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useFindComponentUsageLazyQuery(options) {
  const [getter, _ref24] = useLazyQuery(Queries.FIND_COMPONENT_USAGE_QUERY, options);
  const {
      data
    } = _ref24,
    rest = _objectWithoutPropertiesLoose(_ref24, _excluded45);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    findComponentUsage: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useFindComponentUsageSuspenseQuery(options) {
  const _useSuspenseQuery11 = useSuspenseQuery(Queries.FIND_COMPONENT_USAGE_QUERY, options),
    {
      data
    } = _useSuspenseQuery11,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery11, _excluded46);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    findComponentUsage: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useUpdateAgentInstanceOwnerMutation(options) {
  const [getter, _ref25] = useMutation(Queries.UPDATE_AGENT_INSTANCE_OWNER_MUTATION, options);
  const {
      data
    } = _ref25,
    rest = _objectWithoutPropertiesLoose(_ref25, _excluded47);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    updateAgentInstanceOwner: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useUpdateAgentInstanceFromSnapshotMutation(options) {
  const [getter, _ref26] = useMutation(Queries.UPDATE_AGENT_INSTANCE_FROM_SNAPSHOT_MUTATION, options);
  const {
      data
    } = _ref26,
    rest = _objectWithoutPropertiesLoose(_ref26, _excluded48);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    updateAgentInstanceFromSnapshot: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useCloneInstanceFromSnapshotMutation(options) {
  const [getter, _ref27] = useMutation(Queries.CLONE_INSTANCE_FROM_SNAPSHOT_MUTATION, options);
  const {
      data
    } = _ref27,
    rest = _objectWithoutPropertiesLoose(_ref27, _excluded49);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    cloneInstanceFromSnapshot: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useSubmitPromptFeedbackMutation(options) {
  const [getter, _ref28] = useMutation(Queries.SUBMIT_PROMPT_FEEDBACK_MUTATION, options);
  const {
      data
    } = _ref28,
    rest = _objectWithoutPropertiesLoose(_ref28, _excluded50);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    submitPromptFeedback: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useValidateAgentInstanceReadinessQuery(options) {
  const _useQuery12 = useQuery(Queries.VALIDATE_AGENT_INSTANCE_READINESS_QUERY, options),
    {
      data
    } = _useQuery12,
    rest = _objectWithoutPropertiesLoose(_useQuery12, _excluded51);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    validateAgentInstanceReadiness: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useValidateAgentInstanceReadinessLazyQuery(options) {
  const [getter, _ref29] = useLazyQuery(Queries.VALIDATE_AGENT_INSTANCE_READINESS_QUERY, options);
  const {
      data
    } = _ref29,
    rest = _objectWithoutPropertiesLoose(_ref29, _excluded52);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    validateAgentInstanceReadiness: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useValidateAgentInstanceReadinessSuspenseQuery(options) {
  const _useSuspenseQuery12 = useSuspenseQuery(Queries.VALIDATE_AGENT_INSTANCE_READINESS_QUERY, options),
    {
      data
    } = _useSuspenseQuery12,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery12, _excluded53);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    validateAgentInstanceReadiness: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useValidateAgentInstanceReadinessV2Query(options) {
  const _useQuery13 = useQuery(Queries.VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY, options),
    {
      data
    } = _useQuery13,
    rest = _objectWithoutPropertiesLoose(_useQuery13, _excluded54);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    validateAgentInstanceReadinessV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useValidateAgentInstanceReadinessV2LazyQuery(options) {
  const [getter, _ref30] = useLazyQuery(Queries.VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY, options);
  const {
      data
    } = _ref30,
    rest = _objectWithoutPropertiesLoose(_ref30, _excluded55);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    validateAgentInstanceReadinessV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useValidateAgentInstanceReadinessV2SuspenseQuery(options) {
  const _useSuspenseQuery13 = useSuspenseQuery(Queries.VALIDATE_AGENT_INSTANCE_READINESS_V2_QUERY, options),
    {
      data
    } = _useSuspenseQuery13,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery13, _excluded56);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    validateAgentInstanceReadinessV2: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useBulkValidateAgentInstancesReadinessQuery(options) {
  const _useQuery14 = useQuery(Queries.BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY, options),
    {
      data
    } = _useQuery14,
    rest = _objectWithoutPropertiesLoose(_useQuery14, _excluded57);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkValidateAgentInstancesReadiness: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useBulkValidateAgentInstancesReadinessLazyQuery(options) {
  const [getter, _ref31] = useLazyQuery(Queries.BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY, options);
  const {
      data
    } = _ref31,
    rest = _objectWithoutPropertiesLoose(_ref31, _excluded58);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkValidateAgentInstancesReadiness: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useBulkValidateAgentInstancesReadinessSuspenseQuery(options) {
  const _useSuspenseQuery14 = useSuspenseQuery(Queries.BULK_VALIDATE_AGENT_INSTANCES_READINESS_QUERY, options),
    {
      data
    } = _useSuspenseQuery14,
    rest = _objectWithoutPropertiesLoose(_useSuspenseQuery14, _excluded59);
  const legacyFormatData = useMemo(() => options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkValidateAgentInstancesReadiness: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return Object.assign({
      data: legacyFormatData
    }, rest);
  }
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest);
}
export function useBulkCreateAgentInstancesMutation(options) {
  const [getter, _ref32] = useMutation(Queries.BULK_CREATE_AGENT_INSTANCES_MUTATION, options);
  const {
      data
    } = _ref32,
    rest = _objectWithoutPropertiesLoose(_ref32, _excluded60);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkCreateAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useBulkCreateAgentInstancesByKeyMutation(options) {
  const [getter, _ref33] = useMutation(Queries.BULK_CREATE_AGENT_INSTANCES_BY_KEY_MUTATION, options);
  const {
      data
    } = _ref33,
    rest = _objectWithoutPropertiesLoose(_ref33, _excluded61);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkCreateAgentInstancesByKey: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useBulkUpdateAgentInstancesMutation(options) {
  const [getter, _ref34] = useMutation(Queries.BULK_UPDATE_AGENT_INSTANCES_MUTATION, options);
  const {
      data
    } = _ref34,
    rest = _objectWithoutPropertiesLoose(_ref34, _excluded62);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkUpdateAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}
export function useBulkSoftDeleteAgentInstancesMutation(options) {
  const [getter, _ref35] = useMutation(Queries.BULK_SOFT_DELETE_AGENT_INSTANCES_MUTATION, options);
  const {
      data
    } = _ref35,
    rest = _objectWithoutPropertiesLoose(_ref35, _excluded63);
  const legacyFormatData = useMemo(() => data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
    bulkSoftDeleteAgentInstances: data === null || data === void 0 ? void 0 : data.result
  } : undefined, [data, options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode]);
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    return [getter, Object.assign({
      data: legacyFormatData
    }, rest)];
  }
  return [getter, Object.assign({
    data: data === null || data === void 0 ? void 0 : data.result
  }, rest)];
}